import {ArtifactType, slimUserSchema} from 'shared';
import {z} from 'zod';

export const documentSchema = z.object({
  id: z.string(),
  name: z.string(),
  size: z.number().nonnegative(),
  mime: z.string(),
  type: z.enum(ArtifactType),
  key: z.string().min(1),
  modified: z.coerce.date(),
  createdBy: slimUserSchema,
});

export const documentListSchema = z.array(documentSchema);

export const documentPayloadSchema = z
  .object({
    name: z.string(),
    size: z.number().nonnegative(),
    mime: z.string(),
    type: z.enum(ArtifactType),
    file: z.instanceof(File),
  })
  .array();
